/**
 * ¿Puede esta persona contratar desde /contratar, o ya tiene una organización que paga?
 * (bloque 1 · C3d).
 *
 * Es la primera de tres capas contra el doble cobro; las otras dos son el 409 de
 * `createCheckoutSessionHttp` (C3c) y la guarda del webhook (C3b). Ésta es la única que evita
 * que la persona llegue a rellenar el formulario.
 *
 * DUEÑO, NO MIEMBRO. La lista de organizaciones del contexto trae `ownerId` (el servidor manda
 * el documento entero, `organizationRoutes.js:150-152`). Un invitado es miembro de la
 * organización de otro y SÍ puede crear la suya (decisión de Rodrigo, 6-oct-2026).
 *
 * «VIVA» ES LA MISMA DEFINICIÓN QUE EN EL BACKEND (`functions/billing/organizacionDelDueno.js`
 * → `facturacionViva`). Aquí va escrita como lista de valores crudos porque `src/` no puede
 * importar de `functions/`; la paridad la sostiene `functions/__tests__/decidirContratar.jest.test.js`,
 * que recorre TODOS los valores que conoce `paymentAccess` y exige el mismo veredicto.
 *
 * CommonJS y pura para probarla desde `functions/__tests__` (los tests de `src/` no corren).
 */
const ESTADOS_VIVOS = [
  'active', 'activo',
  'vencido', 'past_due',
  'cancelando', 'canceling',
  'impago', 'unpaid',
  'trial', 'prueba', 'trialing',
  'pausado', 'paused',
  'incompleto', 'incomplete',
];

function facturacionViva(org) {
  const status = org && org.billing && org.billing.status;
  return typeof status === 'string' && ESTADOS_VIVOS.includes(status.trim().toLowerCase());
}

/**
 * @param {{orgs?: Array<object>, uid?: string}} entrada  `organizations` del contexto y el uid
 * @returns {{accion: 'contratar'} | {accion: 'facturacion', orgId: string}}
 */
function decidirContratar({ orgs, uid } = {}) {
  if (!uid || !Array.isArray(orgs)) return { accion: 'contratar' };
  const propiaViva = orgs.find((o) => o && o.ownerId === uid && facturacionViva(o));
  return propiaViva ? { accion: 'facturacion', orgId: propiaViva.id } : { accion: 'contratar' };
}

module.exports = { decidirContratar, facturacionViva, ESTADOS_VIVOS };
